import { render, staticRenderFns } from "./SstDialog.vue?vue&type=template&id=ab96ab4a&scoped=true&"
import script from "./SstDialog.vue?vue&type=script&lang=js&"
export * from "./SstDialog.vue?vue&type=script&lang=js&"
import style0 from "./SstDialog.vue?vue&type=style&index=0&id=ab96ab4a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab96ab4a",
  null
  
)

export default component.exports